import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {AddressProps} from '../types';
import addressesKeys from '../util/addresses-keys';

export interface EditAddressProps {
  name: string;
  address: {
    street: string;
    cityId: string;
    state: string;
    number: string;
    neighborhoodId: string;
    latitude: number;
    longitude: number;
  };
}

const useEditAddress = (id: string) => {
  const {setData} = useQueryHelpers();
  const {update} = useInfiniteQueryHelpers();

  const onSuccess = (data: AddressProps) => {
    setData(addressesKeys.details(id), data);
    update(addressesKeys.list(), data);
  };

  return useApiMutation<EditAddressProps>({
    url: `/addresses/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar endereço',
    successTitle: 'Editar endereço',
    successMessage: 'Endereço atualizado com sucesso',
    onSuccess,
  });
};

export default useEditAddress;
